export default function Spinner({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="w-8 h-8 rounded-full animate-spin" style={{
        border: '1.5px solid rgba(255,255,255,0.06)',
        borderTopColor: '#C89B4C',
      }} />
    </div>
  )
}
